'use client'
import { Typography } from 'components/Contentful'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { Divider } from '@achieve/ascend'
import { mainProductConfig } from 'constants/mainProductConfig'
import {} from 'react'

function AuthorLinks({ links, title, buttons }) {
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'
  return (
    <div className={''}>
      {title ? (
        title
      ) : (
        <Typography
          className={'mb-8 headingMd lg:bodyLg font-normal'}
          content={'Other publications'}
          data-testid="related-articles-title"
        />
      )}
      {links &&
        links.map((link, linkIndex) => {
          return (
            <div className={'mb-8 last:mb-0'} key={linkIndex} data-testid="single-link-container">
              <div className={'mb-6'}>
                <AchieveLink
                  href={link?.fields?.linkHref}
                  target="__blank"
                  rel="noopener noreferrer nofollow"
                  className={'hover:decoration-neutral-900'}
                  track={{
                    list_name: 'Right Rail Title',
                    click_id: link?.linkText?.json?.content?.[0]?.content?.[0]?.value,
                    click_position: linkIndex,
                    click_text: `${
                      mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                    } | ${link?.fields?.linkText?.json?.content?.[0]?.content?.[0]?.value}`,
                    nav_link_section: 'Suggested Content - Right Rail',
                    track_event: 'page_nav_click',
                    event_action: 'link_click',
                    event_type: 'link_click',
                  }}
                  data-testid="related-title-link"
                >
                  <Typography
                    content={link?.fields?.linkText}
                    variant="bodyLg"
                    className={'text-neutral-900 inline'}
                    fontWeight="medium"
                  />
                </AchieveLink>
              </div>

              <AchieveLink
                href={link?.fields?.linkHref}
                target="__blank"
                rel="noopener noreferrer nofollow"
                className={'inline-block'}
                track={{
                  list_name: 'Right Rail Read More',
                  click_id: title,
                  click_position: 'Read the article',
                  click_text: `${
                    mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                  } | Read the article`,
                  nav_link_section: 'Suggested Content - Right Rail',
                  track_event: 'page_nav_click',
                  event_action: 'link_click',
                  event_type: 'link_click',
                }}
                data-testid="related-cta-link"
              >
                <Typography
                  content={buttons ? buttons : 'Read the link'}
                  variant="bodyLg"
                  fontWeight="bold"
                />
              </AchieveLink>

              {linkIndex !== links.length - 1 && <Divider className={'mt-8'} />}
            </div>
          )
        })}
    </div>
  )
}

export { AuthorLinks }
